import { WhitelabelSettingReadModel } from "../../../@api";

export const findWhitelabelSetting = (
  settings: WhitelabelSettingReadModel[],
  key: string,
): WhitelabelSettingReadModel | undefined => {
  return settings.find(setting => setting.key === key);
};
